"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerValidatorDecorator = exports.evaluateBaseConstraints = exports.getChildren = exports.getConstraints = exports.assertValidations = exports.assertValidation = void 0;
const class_validator_1 = require("class-validator");
const isNil_1 = __importDefault(require("lodash/isNil"));
const ErrorCodeV2_1 = require("../../../error/ErrorCodeV2");
const MOLErrorV2_1 = require("../../../error/MOLErrorV2");
// =============================================================================
// General helpers
// =============================================================================
/**
 * Throws an error if the validation fails
 *
 * @param validatorFn Validator function
 * @param name The name of the value being validated, used for crafting the error messsage
 * @param value The value to be validated
 * @param args class-validator arguments
 * @param constraints Custom validator constraints
 */
async function assertValidation(validatorFn, name, value, args, constraints) {
    const result = await validatorFn(value, args, constraints);
    if (!result.pass) {
        throw new MOLErrorV2_1.MOLErrorV2(ErrorCodeV2_1.ErrorCodeV2.SYS_INVALID_PARAM).setMessage(`${name}: ${result.message}`);
    }
}
exports.assertValidation = assertValidation;
/**
 * Throws an error if the validation fails
 *
 * @param object The object to be validated (should be using class-validator decorators)
 * @param validatorOptions class-validator options
 */
async function assertValidations(object, validatorOptions) {
    const results = await (0, class_validator_1.validate)(object, {
        validationError: { target: false, value: false },
        forbidUnknownValues: true,
        ...validatorOptions,
    });
    if (results.length > 0) {
        throw new MOLErrorV2_1.MOLErrorV2(ErrorCodeV2_1.ErrorCodeV2.SYS_INVALID_PARAM).setResponseData(results);
    }
}
exports.assertValidations = assertValidations;
/**
 * Used for extracting specific `ValidationError` constraints
 */
function getConstraints(errors, property) {
    var _a;
    return (_a = errors.find((error) => error.property === property)) === null || _a === void 0 ? void 0 : _a.constraints;
}
exports.getConstraints = getConstraints;
/**
 * Used for extracting specific `ValidationError` children
 */
function getChildren(errors, property) {
    var _a;
    return (_a = errors.find((error) => error.property === property)) === null || _a === void 0 ? void 0 : _a.children;
}
exports.getChildren = getChildren;
// =============================================================================
// Validator implementation helpers
// =============================================================================
async function evaluateBaseConstraints(value, args, constraints) {
    if ((0, isNil_1.default)(constraints)) {
        return true;
    }
    if (!!constraints.isOptional && (0, isNil_1.default)(value)) {
        return false;
    }
    if ((0, isNil_1.default)(constraints.if)) {
        return true;
    }
    const conditions = [].concat(constraints.if);
    const conditionResults = await Promise.all(conditions.map((mapCondition) => mapCondition(value, args)));
    const allConditionsPassed = conditionResults.every((conditionResult) => conditionResult);
    return allConditionsPassed;
}
exports.evaluateBaseConstraints = evaluateBaseConstraints;
function registerValidatorDecorator(params) {
    return (object, propertyName) => {
        let defaultMessage = params.defaultMessage;
        (0, class_validator_1.registerDecorator)({
            async: true,
            name: params.name,
            target: object.constructor,
            propertyName,
            options: params.options,
            constraints: [params.constraints],
            validator: {
                validate: async (value, args) => {
                    var _a;
                    const validationResults = await params.validateFn(value, args, params.constraints);
                    defaultMessage = (_a = validationResults.message) !== null && _a !== void 0 ? _a : defaultMessage;
                    return validationResults.pass;
                },
                defaultMessage: () => {
                    return defaultMessage;
                },
            },
        });
    };
}
exports.registerValidatorDecorator = registerValidatorDecorator;
//# sourceMappingURL=mol-validator-utils.js.map